import React, {Component} from "react";
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  Label,
  FormGroup,
} from "reactstrap";
import TranslationInput from "../../03-components/TranslationInput";
import FileUploader from "../../03-components/FileUploader";
import CategorySelector from "../CategorySelector";
import {
  convertFromTranslationObject,
  convertToTranslationObject,
} from "../../05-utils/commonUtils";
import {getEnv} from "../../env";
import "./style.css";

export default class CategoryDialog extends Component {
  constructor(props) {
    super(props);
    this.editMode = props.options && props.options.editMode;
    this.state = {
      categoryId: props.options && props.options.value.categoryId,
      name: (props.options && props.options.value.name) || "",
      description:
        props.options &&
        convertFromTranslationObject(props.options.value.description),
      isFeatured: !!(props.options && props.options.value.isFeatured),
      img1: props.options && props.options.value.img1,
      img2: props.options && props.options.value.img2,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleOK = this.handleOK.bind(this);
    this.handleInputValue = this.handleInputValue.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
  }

  handleInputValue(field) {
    return (value) => {
      this.setState({[field]: value});
    };
  }

  handleCheckbox(field) {
    return () => {
      this.setState({[field]: !this.state[field]});
    };
  }

  isFormValid() {
    return this.state.name && this.state.categoryId;
  }

  handleClose() {
    this.props.onClose();
  }

  handleOK() {
    this.props.onOK(this.props.options, {
      categoryId: this.state.categoryId,
      name: this.state.name,
      description: convertToTranslationObject(this.state.description),
      img1: this.state.img1 || null,
      img2: this.state.img2 || null,
      isFeatured: this.state.isFeatured,
    });
  }

  render() {
    return (
      <Modal size={"lg"} className="con-productdialog" isOpen={true}>
        <ModalHeader>{`${this.editMode ? "Edit" : "Add"} product`}</ModalHeader>
        <ModalBody>
          <div className="input-group">
            <div className="label">Product category</div>
            <CategorySelector
              withProductCount={false}
              value={this.state.categoryId}
              onSelected={(value) => {
                this.handleInputValue("categoryId")(value);
              }}
            />
          </div>
          <div className="input-group">
            <div className="label">Product name</div>
            <div>
              <Input
                value={this.state.name}
                onChange={(e) => {
                  this.handleInputValue("name")(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-group">
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={this.state.isFeatured}
                  onChange={(e) => {
                    this.handleCheckbox("isFeatured")();
                  }}
                />{" "}
                Feature this product
              </Label>
            </FormGroup>
          </div>
          <div className="input-group">
            <div className="label">Product description</div>
            <TranslationInput
              value={this.state.description}
              type="multi"
              onValueChange={(value) => {
                this.handleInputValue("description")(value);
              }}
            />
          </div>
          <div className={"d-flex"} style={{gap: 13}}>
            <div className="input-group">
              <div className="label">Product profile photo</div>
              <div className="d-flex">
                {this.editMode && this.state.img1 ? (
                  <div className="d-flex">
                    <Card className="product-photo">
                      <img
                        style={{width: "100%"}}
                        src={
                          getEnv("S3_ASSETS_BUCKET") +
                          "/" +
                          this.state.img1 +
                          "?" +
                          Date.now()
                        }
                        alt="profile"
                      />
                    </Card>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        this.setState({img1: null});
                      }}
                    >
                      <i className=" fas fa-ban" />
                    </Button>
                  </div>
                ) : (
                  <FileUploader onChange={this.handleInputValue("img1")} />
                )}
              </div>
            </div>
            <div className="input-group">
              <div className="label">Product description photo</div>
              <div className="d-flex">
                {this.editMode && this.state.img2 ? (
                  <div className="d-flex">
                    <Card className="product-photo">
                      <img
                        style={{width: "100%"}}
                        src={
                          getEnv("S3_ASSETS_BUCKET") +
                          "/" +
                          this.state.img2 +
                          "?" +
                          Date.now()
                        }
                        alt="detail"
                      />
                    </Card>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        this.setState({img2: null});
                      }}
                    >
                      <i className=" fas fa-ban" />
                    </Button>
                  </div>
                ) : (
                  <FileUploader onChange={this.handleInputValue("img2")} />
                )}
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="margin-right-15px" onClick={this.handleClose}>
            {"Cancel"}
          </Button>
          <Button
            disabled={!this.isFormValid()}
            color="primary"
            onClick={this.handleOK}
          >
            {`${this.editMode ? "Save" : "Add"}`}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/04-containers/ProductDialog/index.js